import Button from '../Button/Button';
import './CupBuilderHeader.css';
import { ReactComponent as UndoIcon } from "../../../assets/icons/svg/undo-left-round-svgrepo-com.svg";
import { ReactComponent as ClearIcon } from '../../../assets/icons/svg/clear-inverse-svgrepo-com.svg';

/**
 * Shared header component for cup builders across different game modes.
 * Displays current track selection progress and undo/reset controls.
 * 
 * @param {Function} onUndo - Callback to undo last track selection
 * @param {Function} onReset - Callback to reset entire cup
 * @param {number} currentTrackNumber - Current track being selected (1-4)
 * @param {number} totalTracks - Total number of tracks in cup (default: 4)
 * @param {boolean} isDisabled - Whether undo button should be disabled
 * @param {string} variant - Button style variant ('mk8dx' or 'world')
 * @param {string} color - Button color preset (optional, defaults based on variant)
 */
export default function CupBuilderHeader({
    onUndo,
    onReset,
    currentTrackNumber,
    totalTracks = 4,
    isDisabled = false,
    variant = 'mk8dx',
    color
}) {


    return (
        <div className="cup-builder-header">
            <Button
                text="Undo"
                icon={UndoIcon}
                onClick={onUndo}
                disabled={isDisabled}
                variant={variant}
                color="white"
            />

            <h2>{`Select track #${currentTrackNumber}/${totalTracks}`}</h2>

            <Button
                text="Clear"
                icon={ClearIcon}
                onClick={onReset}
                variant={variant}
                color="red"
            />
        </div>
    );
}
